/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Large_Json_Files_Faq_Q3Inputs */

const en_guide_large_json_files_faq_q3 = /** @type {(inputs: Guide_Large_Json_Files_Faq_Q3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How large a JSON file can a browser handle?`)
};

const ko_guide_large_json_files_faq_q3 = /** @type {(inputs: Guide_Large_Json_Files_Faq_Q3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`브라우저는 얼마나 큰 JSON 파일을 다룰 수 있나요?`)
};

const ja_guide_large_json_files_faq_q3 = /** @type {(inputs: Guide_Large_Json_Files_Faq_Q3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ブラウザはどれくらい大きな JSON ファイルを扱えますか?`)
};

/**
* | output |
* | --- |
* | "How large a JSON file can a browser handle?" |
*
* @param {Guide_Large_Json_Files_Faq_Q3Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_large_json_files_faq_q3 = /** @type {((inputs?: Guide_Large_Json_Files_Faq_Q3Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Large_Json_Files_Faq_Q3Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_large_json_files_faq_q3(inputs)
	if (locale === "ko") return ko_guide_large_json_files_faq_q3(inputs)
	return ja_guide_large_json_files_faq_q3(inputs)
});